import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormMessageHOC } from 'common/HOCs';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { injectIntl } from 'react-intl';
import { ActionsButton, BasicModal, PaginationTable, StatusCell, DateCell } from 'common/components';
import { ModalHOC } from 'common';
import { withTheme } from 'common/styling/theme';
import DownloadReportForm from '../DownloadReportForm';
import { BasketIcon } from '../../../icons';
import { staticStyles, getDynamicStyles } from './style';

const SavedReportsTable = ({
  data,
  getList,
  loading,
  history,
  location,
  params,
  showFormSuccessMessage,
  showModal,
  deleteReport,
  intl,
  theme,
}) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  const [modal, setModal] = useState({ isOpen: false, payload: '' });
  const toggleModal = () => setModal({ ...modal, isOpen: !modal.isOpen });

  const handleDeleteReport = (e, reportId) => {
    e.stopPropagation();
    showModal({
      caption: { id: 'confirmText' },
      content: {
        id: 'confirmDeleteReport',
      },
      actionButton: {
        textId: 'justYes',
        handler: () => deleteReport({ reportId, reportType: 'saved', queryParams: params }),
        type: 'error',
      },
      cancelButton: {
        textId: 'justNo',
      },
    });
  };

  /* eslint-disable */
  const columns = [
    {
      Header: 'justIbAccount',
      accessor: 'partner',
      Cell: ({
        row: {
          original: { params },
        },
      }) => (
        <CopyToClipboard
          text={(params?.partner ?? '').trim()}
          onCopy={() => {
            showFormSuccessMessage(`${params?.partner} copied to clipboard`);
          }}>
          <span className="SavedReportsTable__ib-account">{params?.partner || '-'}</span>
        </CopyToClipboard>
      ),
      isPreviewCell: true,
    },
    {
      Header: 'justDate',
      accessor: 'updated',
      Cell: ({
        row: {
          original: { updated },
        },
      }) => <DateCell value={updated} />,
    },
    {
      Header: 'boStatus',
      accessor: 'status',
      Cell: ({
        row: {
          original: { status },
        },
      }) => <StatusCell statusCode={status} />,
      isPreviewCell: true,
    },
    {
      Header: 'justReportName',
      accessor: 'name',
      Cell: ({
        row: {
          original: { name },
        },
      }) => <span className="SavedReportsTable__template">{name}</span>,
      isPreviewCell: true,
    },
    {
      Header: 'justPeriod',
      accessor: 'period',
      Cell: ({
        row: {
          original: { params },
        },
      }) => <span>{`${intl.formatDate(params.start_date)} - ${intl.formatDate(params.end_date)}`}</span>,
    },
    {
      Header: 'justActions',
      Cell: ({ row: { original: report } }) => (
        <ActionsButton
          tooltipId={`Delete__tooltip-${report.id}`}
          tooltipTextId="justDelete"
          deleteType
          onClickFunc={e => handleDeleteReport(e, report.id)}>
          <BasketIcon />
        </ActionsButton>
      ),
    },
  ];
  /* eslint-enable */
  const handleRowClick = (_, row) => {
    const report = data.results.find(report => report.id === row.original.id);
    if (report.status === 'SUCCESS') {
      setModal({ isOpen: true, payload: report });
    }
  };

  return (
    <div className="SavedReportsTable">
      <PaginationTable
        data={data}
        loading={loading}
        columns={columns}
        onRowClick={handleRowClick}
        getList={getList}
        location={location}
        history={history}
        params={params}
      />
      <BasicModal isOpen={modal.isOpen} captionId="justDownloadReport" onRequestClose={toggleModal}>
        <DownloadReportForm toggleModal={toggleModal} report={modal.payload} />
      </BasicModal>
      <style jsx global>
        {staticStyles}
      </style>
      <style jsx global>
        {dynamicStyles}
      </style>
    </div>
  );
};

SavedReportsTable.propTypes = {
  showModal: PropTypes.func.isRequired,
  deleteReport: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  getList: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  theme: PropTypes.object,
};

SavedReportsTable.defaultProps = {
  theme: {},
};

export default compose(injectIntl, FormMessageHOC, ModalHOC, withTheme())(SavedReportsTable);
export { SavedReportsTable };
